import classNames from '@utils/classnames';
import React from 'react';

import { controlClassName } from '../form/control';

export interface TextAreaProps {
  id?: string;
  value: string;
  onBlur?: (e: React.FocusEvent<any>) => void;
  onFocus?: () => void;
  onChange: (newValue: string) => void;
  isInvalid?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
  rows?: number;
  cols?: number;
  spellCheck?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

export const TextArea: React.FC<TextAreaProps> = (props) => {
  const {
    id,
    value,
    onBlur,
    onFocus,
    onChange,
    isInvalid,
    isDisabled,
    placeholder,
    rows,
    cols,
    spellCheck,
    onKeyDown,
  } = props;

  return (
    <textarea
      id={id}
      rows={rows}
      cols={cols}
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      onChange={(evt) => onChange(evt.target.value)}
      className={classNames(
        controlClassName({ isInvalid, isDisabled, focusWithin: false }),
        'block h-auto px-2.5 py-2',
      )}
      disabled={isDisabled}
      autoComplete="off"
      spellCheck={spellCheck}
      onKeyDown={onKeyDown}
    />
  );
};
